// for now using this value instead of @ha/intl because of
// nx limitation https://github.com/nrwl/nx/issues/10565

export enum Language {
  en = 'en',
  fr = 'fr',
  de = 'de',
  es = 'es',
  it = 'it',
  nl = 'nl',
  pt = 'pt',
  zh = 'zh',
  uk = 'uk',
  ru = 'ru',
  pl = 'pl',
  sv = 'sv',
  ro = 'ro',
}
